import {
  CreateExportsConfigurationDocument,
  CreateExportsConfigurationMutationVariables,
  ExportsConfigurationDocument,
  ExportsConfigurationQueryVariables,
  UpdateExportsConfigurationDocument,
  UpdateExportsConfigurationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useCreateConfiguration = () => {
  const [createConfiguration, { loading }] = useMutation(CreateExportsConfigurationDocument, {
    extractorFn: (data) => data.universalExportsMutations.createUniversalexportsConfiguration,
  })

  return {
    create: (variables: CreateExportsConfigurationMutationVariables) =>
      createConfiguration({ variables }),
    loading,
  }
}

export const useConfiguration = (
  variables: ExportsConfigurationQueryVariables,
  hasDynamicFields?: boolean
) => {
  const { data, loading } = useQuery(ExportsConfigurationDocument, {
    variables,
  })
  const node = data?.universalExports.configurationsConnection.nodes[0]

  if (hasDynamicFields) {
    return {
      loading: false,
      id: undefined,
      fields: [],
      filters: [],
      extraOptions: [],
    }
  }

  return {
    loading,
    id: node?.id,
    fields: node?.fields ?? [],
    filters: node?.filters ?? [],
    extraOptions: node?.extraOptions ?? [],
    format: node?.format,
    groupColumn: node?.groupColumn,
  }
}

export const useUpdateConfiguration = () => {
  const [updateConfiguration, { loading }] = useMutation(UpdateExportsConfigurationDocument, {
    extractorFn: (data) => data.universalExportsMutations.updateUniversalexportsConfiguration,
  })

  return {
    update: (variables: UpdateExportsConfigurationMutationVariables) =>
      updateConfiguration({ variables }),
    loading,
  }
}
